import { Component } from '@angular/core';

@Component({
  selector: 'app-validation-page-b',
  templateUrl: './validation-page-b.component.html',
  styleUrls: ['./validation-page-b.component.css'],
})
export class ValidationPageBComponent {
  title1 = 'Validation';
  title = 'Seller Information';
  title2 = 'Document Validation';
}
